import { render } from "./SpinnerLoader.vue?vue&type=template&id=a910f882"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__